var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"member"},[_c('h3',{staticClass:"username"},[_vm._v(" "+_vm._s(_vm.user.username)+" ")])]),_c('button',{on:{"click":_vm.removeMember}},[_vm._v(" ❌ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }